import { styled } from '@mui/material/styles';
import { Navigate, Route, Routes } from 'react-router-dom';
import NavbarWrapperLayout from './NavbarWrapperLayout';
import ToolbarLayout from './ToolbarLayout';
import { useAuthCore } from '../../core/modules/auth';
import { useGlobalCore } from '../../core/modules/global';
import Users from '../screens/dashboard/users/Users';
import { SIGNIN } from '../../core/router/routes';
import Welcome from '../screens/dashboard/Welcome';
import { ToastContainer } from 'react-toastify';
import UserDialog from '../components/UserDialog';
import Articles from '../screens/dashboard/administration/articles/Articles';
import Companies from '../screens/dashboard/companies/Companies';
import Types from '../screens/dashboard/administration/masters/Types';
import Categories from '../screens/dashboard/administration/masters/Categories';
import Formats from '../screens/dashboard/administration/masters/Formats';
import Genres from '../screens/dashboard/administration/masters/Genres';
import PriceRanges from '../screens/dashboard/administration/masters/PriceRanges';
import Businesses from '../screens/dashboard/administration/businesses/Businesses';
import Containers from '../screens/dashboard/administration/containers/containers';
import CreateArticle from '../screens/dashboard/administration/articles/CreateArticle';
import EditArticle from '../screens/dashboard/administration/articles/EditArticle';
import Warehouses from '../screens/dashboard/administration/warehouses/Warehouses';
import Locations from '../screens/dashboard/administration/locations/Locations';
import Receptions from '../screens/dashboard/operations/receptions/Receptions';
import LocateContainer from '../screens/dashboard/operations/LocateContainer';
import ValidContainer from '../screens/dashboard/operations/ValidContainer';
import { ContainerClassificationScreen } from '../screens/operations/ContainerClassificationScreen';
import ValorativeClassification from '../screens/dashboard/operations/ValorativeClassification';
import ClassifyAgain from '../screens/dashboard/operations/ClassifyAgain';
import PreClassification from '../screens/dashboard/operations/PreClassification';
import ReceptionOrders from '../screens/dashboard/operations/ReceptionOrders';
import ReceptionContainers from '../screens/dashboard/operations/receptions/ReceptionContainers';
import SearchContainers from '../screens/dashboard/queries/Containers';
import SearchArticles from '../screens/dashboard/queries/Articles';
import ContainerAuditScreen from '../screens/dashboard/queries/ContainerAudit';

import Attributes from '../screens/dashboard/administration/masters/Attributes';
import ContainerProducts from '../screens/dashboard/operations/ContainerProducts';
import LocationsReport from '../screens/dashboard/queries/LocationsReport';
import { ReclassifyScreen } from '../screens/operations/ReclassifyScreen';
import Valorization from '../screens/dashboard/operations/Valorization';
import Tools from '../screens/dashboard/operations/Tools';

const Root = styled('div')(() => ({
  '& .container': {
    maxWidth: '1570px',
    width: '100%',
    margin: '0 auto',
  },
}));

const Layout = () => {
  const { token } = useAuthCore();
  const { opened } = useGlobalCore();

  if (!token) {
    return <Navigate to={SIGNIN} replace />;
  }

  return (
    <Root id="fuse-layout" className="w-full flex">
      <ToastContainer />
      <div className="flex flex-auto min-w-0">
        <NavbarWrapperLayout />

        <main
          id="fuse-main"
          className="flex flex-col flex-auto min-h-full min-w-0 relative z-10"
          style={{ marginLeft: opened ? '280px' : '76px' }}
        >
          <ToolbarLayout className="fixed" />

          <div className="flex flex-col flex-auto min-h-0 relative z-10">
            <Routes>
              {/* Masters */}
              <Route path="/masters/attributes" element={<Attributes />} />
              <Route path="/masters/types" element={<Types />} />
              <Route path="/masters/categories" element={<Categories />} />
              <Route path="/masters/formats" element={<Formats />} />
              <Route path="/masters/priceRanges" element={<PriceRanges />} />
              <Route path="/masters/genres" element={<Genres />} />
              {/* Articles */}
              <Route path="/article/add" element={<CreateArticle />} />
              <Route path="/article/edit" element={<EditArticle />} />
              <Route path="/articles" element={<Articles />} />
              {/* General */}
              <Route
                path="/"
                element={<Navigate to="/dashboard/welcome" replace />}
              />
              <Route path="/welcome" element={<Welcome />} />
              <Route path="/containers" element={<Containers />} />
              <Route path="/businesses" element={<Businesses />} />
              <Route path="/locations" element={<Locations />} />
              <Route path="/warehouses" element={<Warehouses />} />
              <Route
                path="*"
                element={<Navigate to="/dashboard/welcome" replace />}
              />
              {/* Operations */}
              <Route
                path="/operations/receptionOrders"
                element={<ReceptionOrders />}
              />
              <Route path="/operations/receptions" element={<Receptions />} />
              <Route
                path="/operations/receptions/:id/containers"
                element={<ReceptionContainers />}
              />
              <Route
                path="/operations/valid-container"
                element={<ValidContainer />}
              />
              <Route
                path="/operations/container/:id/products"
                element={<ContainerProducts />}
              />
              <Route
                path="/operations/container-classification"
                element={<ContainerClassificationScreen />}
              />
              <Route
                path="/operations/valorative-classification"
                element={<ValorativeClassification />}
              />
              <Route
                path="/operations/locate-container"
                element={<LocateContainer />}
              />
              <Route
                path="/operations/classify-again"
                element={<ClassifyAgain />}
              />
              <Route
                path="/operations/articles-check"
                element={<Receptions />}
              />
              <Route
                path="/operations/pre-classification"
                element={<PreClassification />}
              />
              <Route
                path="/operations/reclassify"
                element={<ReclassifyScreen />}
              />
              <Route
                path="/operations/valorization"
                element={<Valorization />}
              />
              <Route
                path="/operations/tools"
                element={<Tools />}
              />
              {/* Queries */}
              <Route path="/queries/articles" element={<SearchArticles />} />
              <Route
                path="/queries/containers"
                element={<SearchContainers />}
              />
              <Route
                path="/queries/locations-report"
                element={<LocationsReport />}
              />
              <Route
                path="/queries/container-audit"
                element={<ContainerAuditScreen />}
              />
              {/* Admin */}
              <Route path="/users" element={<Users />} />
              <Route path="/companies" element={<Companies />} />
            </Routes>
          </div>
        </main>
      </div>
      <UserDialog />
    </Root>
  );
};

export default Layout;
